import React, { useEffect, useState } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { withAuth } from '../AuthContext'
import { getCurrencySign } from '../../utils/utils'
import styled from 'styled-components'
import Error from '../Utils/Error'
import Paypal from './Paypal'
import { decode } from 'html-entities'
import { gaEvents } from '../../analytics/events'
import { Box, Slider } from '@mui/material'
import { shouldTranslateTo } from '../../utils/utils'
import CustomImage from '../Utils/CustomImage'

import {
  Title,
  Subtitle,
  GreenBoldSub,
  ActionButtons,
  LoadingButton,
  PrimaryOutlineButton,
} from '../Utils/CustomClasses'

const ContainerBox = styled.div`
  padding: 30px 36px 55px 36px;
  background-color: #ffffff;

  @media (max-width: 767px) {
    padding: 25px 25px 25px 25px;
  }
`

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  align-items: flex-end;
  justify-content: flex-end;
  margin-top: 60px;

  @media (max-width: 767px) {
    flex-direction: column;
    margin-top: 0;
  }
`

const Center = styled.div`
  text-align: center;
  margin-top: 40px;
`

const CenterSmallMargin = styled(Center)`
  margin-top: 30px;
`

const BackButton = styled(ActionButtons)`
  background-color: #fff;
  border: 1px solid #000;
  color: #000;
  display: inline-block;

  @media screen and (max-width: 768px) {
    margin: 10px 0 0;
  }

  @media screen and (min-width: 769px) {
    max-width: 150px;
  }
`

const PriceChoiceBox = styled.div`
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 5px 9px -2px #b5b5b5;
  border: 1px solid #eee;
  padding: 30px 20px;
  margin: 40px 0 0;
  width: 100%;
`

const PriceChoiceButton = styled.button`
  border-radius: 5px;
  padding: 18px 26px;
  background-color: transparent;
  border: 2px solid #3f51b5;
  margin: 1%;

  width: 23%;

  @media screen and (max-width: 1000px) {
    width: 48%;
  }

  @media screen and (max-width: 550px) {
    width: 98%;
  }

  a {
    color: #3f51b5;
  }
`

const FlexRowTrust = styled.div`
  display: flex;
  flex-direction: row;
  ${(props) => props.gap && `gap: ${props.gap}`};
  /* flex-wrap: wrap; */

  > div {
    width: 50%;
  }

  @media only screen and (max-width: 980px) {
    flex-wrap: wrap;

    > div {
      width: 100%;
    }
  }

  @media only screen and (max-width: 980px) {
    gap: ${(props) => (props.gapSm ? props.gapSm : '0')};
    ${(props) => props.reverse && 'flex-direction: column-reverse;'}
    flex-wrap: wrap;
    > div {
      width: 100%;
    }
  }

  @media only screen and (max-width: 600px) {
    gap: ${(props) => (props.gapSm ? props.gapSm : '0')};
    ${(props) => props.reverse && 'flex-direction: column-reverse;'}
    flex-wrap: wrap;
    > div {
      width: 100%;
    }
  }
`

const Sections = styled.div`
  padding: 74px 5vw 30px 5vw;
  background-color: ${({ color }) => (color ? color : '#fff')};
  § img {
    width: 100%;
  }

  ${(props) => props.last && 'padding: 74px 5vw 130px 5vw;'}

  @media only screen and (max-width: 980px) {
    padding: 32px 0 30px 0;
    ${(props) => props.last && 'padding: 24px 3vw 90px 5vw;'}
  }

  @media only screen and (max-width: 600px) {
    padding: 24px 0 30px 0;
    ${(props) => props.last && 'padding: 24px 3vw 90px 5vw;'}
  }
`

const SafetySection = styled(Sections)`
  margin: 20px 0 0;
  padding: 34px 0 30px 0;
`

const SectionText = styled.div`
  &:first-of-type {
    margin: auto 4.5vw auto 0;

    @media only screen and (max-width: 1024px) {
      margin: auto 4vw auto 0;
    }

    @media only screen and (max-width: 980px) {
      margin: auto 0;
    }

    @media only screen and (max-width: 600px) {
      margin: auto 0;
    }
  }

  &:last-of-type {
    margin: auto 6vw auto 6vw;

    @media only screen and (max-width: 1024px) {
      margin: auto 4vw auto 4vw;
    }

    @media only screen and (max-width: 980px) {
      margin: auto 0;
    }

    @media only screen and (max-width: 600px) {
      margin: auto 0;
    }
  }
`

const CustomImageWrapper = styled.div`
  & > div {
    margin: 0 auto;
  }
`

const ChooseMembershipFeeApp = ({ data, onUpdate }) => {
  const [defaultMembershipFee, setDefaultMembershipFee] = useState('30')
  const [savedMembershipFee, setSavedMembershipFee] = useState('')
  const [membershipFee, setMembershipFee] = useState('')
  const [membershipFeeStatus, setMembershipFeeStatus] = useState('')
  const [currencySign, setCurrencySign] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [marks, setMarks] = useState([])
  const [checkout, setCheckout] = useState(false)
  const [value, setValue] = useState('')
  const [pageText, setPageText] = useState([])
  const [pageText2, setPageText2] = useState([])

  useEffect(() => {
    gaEvents.eventGeneric(
      'page_load',
      'choose-membership-fee-page-loaded',
      data.auth.user.id + ' - choose membership fee - page loaded'
    )

    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          pageValue === 'profile-pay'
            ? setPageText(pageText)
            : setPageText2(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    const getCurrency = async () => {
      const currencySignData = await getCurrencySign(
        data.auth.user.currencyValue
      )
      setCurrencySign(currencySignData.sign)
    }

    const marks = [
      {
        value: 1,
        label: decode(currencySign) + '1',
      },
      {
        value: 20,
        label: decode(currencySign) + '20',
      },
      {
        value: 40,
        label: decode(currencySign) + '40',
      },
      {
        value: 60,
        label: decode(currencySign) + '60',
      },
      {
        value: 80,
        label: decode(currencySign) + '80',
      },
      {
        value: 100,
        label: decode(currencySign) + '100',
      },
    ]

    getCurrency()

    if (
      data.auth.user.membershipFee !== null &&
      data.auth.user.membershipFee !== undefined
    ) {
      setValue(data.auth.user.membershipFee)
      setMembershipFee(data.auth.user.membershipFee)
    } else {
      setValue(defaultMembershipFee)
      setMembershipFee(defaultMembershipFee)
    }
    setMarks(marks)
    getPageText('profile-pay', language)
    getPageText('homepage-v2', language)
  }, [])

  const handleMembershipFeeChange = (value) => {
    gaEvents.eventGeneric(
      'button_click',
      'price-slider-updated',
      data.auth.user.id +
        ' - choose membership fee - ' +
        value +
        ' - drop down menu - price chosen'
    )
    const membershipFee = value

    if (membershipFee < 5) {
      setMembershipFee(1)
      setSavedMembershipFee(1)
      setValue(1)
      setError('')
    } else {
      setMembershipFee(membershipFee)
      setSavedMembershipFee(membershipFee)
      setValue(membershipFee)
      setError('')
    }
  }

  const handleSetPriceButton = (fee) => {
    gaEvents.eventGeneric(
      'button_click',
      'price-choice-button-clicked',
      data.auth.user.id +
        ' - choose membership fee - ' +
        fee +
        ' - drop down menu - price chosen'
    )
    setMembershipFee(fee)
    setSavedMembershipFee(fee)
    setValue(fee)
    setError('')
  }

  const checkPriceChoice = () => {
    if (
      Number(membershipFee) !== 5 &&
      Number(membershipFee) !== 15 &&
      Number(membershipFee) !== 30 &&
      Number(membershipFee) !== 45
    ) {
      setLoading(false)
      setError('Please choose a membership fee option')
      return false
    } else {
      return true
    }
  }

  const handleChooePaypal = () => {
    if (!checkPriceChoice()) {
      return
    }

    gaEvents.eventGeneric(
      'button_click',
      'paypal-chosen',
      data.auth.user.id + ' - choose membership fee - button - choose Paypal'
    )

    setMembershipFeeStatus('pending')

    const userData = {
      membershipFee: membershipFee,
      membershipFeeStatus: 'pending',
      currencySign: currencySign,
    }

    data.auth.updateUser(userData).then(() => {
      setCheckout(true)
    })
  }

  const valuetext = (value) => {
    return `${value}`
  }

  const valueLabelFormat = (value) => {
    return decode(currencySign) + value.toString()
  }

  const handleSubmit = () => {
    gaEvents.eventGeneric(
      'button_click',
      'stripe-chosen',
      data.auth.user.id + ' - choose membership fee - button - choose Stripe'
    )

    setLoading(true)
    setError('')

    if (!checkPriceChoice()) {
      return
    }

    var membershipFeeStatus = ''

    if (membershipFee === 0) {
      membershipFeeStatus = 'completed'
    } else {
      membershipFeeStatus = 'pending'
    }

    const userData = {
      membershipFee: membershipFee,
      membershipFeeStatus: membershipFeeStatus,
      currencySign: currencySign,
    }

    setMembershipFeeStatus(membershipFeeStatus)

    data.auth.updateUser(userData).then(() => {
      setTimeout(function () {
        onUpdate()
        setLoading(false)
      }, 1000)
    })
  }

  if (!currencySign || pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">{pageText[10]}</span>
        </div>
      </div>
    )
  }
  return (
    <div className="container">
      <div className="row justify-content-center">
        {checkout ? (
          <div>
            <div>
              <Paypal
                user={data.auth.user}
                membershipFee={membershipFee}
                currencySign={data.auth.user.currencyValue}
              />
            </div>

            <div className="text-center">
              <BackButton
                type="submit"
                padding="10px 40px"
                margin="15px 0 20px 12px"
                onClick={(e) => {
                  setCheckout(false)
                }}
              >
                {pageText[10]}
              </BackButton>
            </div>
          </div>
        ) : (
          <ContainerBox>
            {data.auth.user.membershipFeeStatus === 'completed' ? (
              <>
                <Title
                  center
                  size="29px"
                  sizemd="29px"
                  sizesm="24px"
                  margin="0 0 20px 0"
                  dangerouslySetInnerHTML={{
                    __html: `${pageText[1]}`,
                  }}
                ></Title>
                <Subtitle
                  center
                  weight="400"
                  size="20px"
                  margin="20px 0 20px 0"
                  dangerouslySetInnerHTML={{
                    __html: `${pageText[12]} ${currencySign}${data.auth.user.membershipFee}`,
                  }}
                />
              </>
            ) : (
              <form
                method="POST"
                action="/"
                name="myForm"
                aria-label="Add Profile"
                onSubmit={(event) => {
                  event.preventDefault()
                  return false
                }}
                style={{ marginTop: 0 }}
              >
                <input
                  type="hidden"
                  name="csrf-token"
                  value={window.Laravel.csrfToken}
                />

                <Title
                  size="29px"
                  sizemd="29px"
                  sizesm="26px"
                  margin="0 0 20px 0"
                  dangerouslySetInnerHTML={{
                    __html: `${pageText[1]}`,
                  }}
                ></Title>

                <Subtitle size="20px" sizesm="20px" bold margin="28px 0 20px 0">
                  {pageText[11]}
                </Subtitle>

                <GreenBoldSub
                  size="18px"
                  sizesm="20px"
                  dangerouslySetInnerHTML={{
                    __html: `${
                      pageText[2] +
                      ' ' +
                      currencySign +
                      '5, ' +
                      currencySign +
                      '15, ' +
                      currencySign +
                      '30, ' +
                      pageText[3] +
                      ' ' +
                      currencySign +
                      '45. ' +
                      pageText[4]
                    }`,
                  }}
                ></GreenBoldSub>

                <CenterSmallMargin>
                  <img
                    src="/images/icons/licensePaypal.svg"
                    alt=""
                    className="img-secured-by-stripe-mini-app3"
                  />
                  <img
                    src="/images/icons/licensePaypal-mobile2.svg"
                    alt=""
                    className="img-secured-by-stripe-mini-mobile-app3"
                  />
                </CenterSmallMargin>

                <PriceChoiceBox>
                  <Subtitle size="20px" bold margin="0 0 10px 1%">
                    {pageText[5]}
                  </Subtitle>
                  <div className="price-buttons-container">
                    <PriceChoiceButton
                      onClick={() => {
                        handleSetPriceButton(5)
                      }}
                      className={
                        membershipFee == 5 ? 'pbutton-live' : 'pbutton'
                      }
                    >
                      <a>Choose {decode(currencySign)}5</a>
                    </PriceChoiceButton>
                    <PriceChoiceButton
                      onClick={() => {
                        handleSetPriceButton(15)
                      }}
                      className={
                        membershipFee == 15 ? 'pbutton-live' : 'pbutton'
                      }
                    >
                      <a>Choose {decode(currencySign)}15</a>
                    </PriceChoiceButton>
                    <PriceChoiceButton
                      onClick={() => {
                        handleSetPriceButton(30)
                      }}
                      className={
                        membershipFee == 30 ? 'pbutton-live' : 'pbutton'
                      }
                    >
                      <a>Choose {decode(currencySign)}30</a>
                    </PriceChoiceButton>
                    <PriceChoiceButton
                      onClick={() => {
                        handleSetPriceButton(45)
                      }}
                      className={
                        membershipFee == 45 ? 'pbutton-live' : 'pbutton'
                      }
                    >
                      <a>Choose {decode(currencySign)}45</a>
                    </PriceChoiceButton>
                  </div>

                  <div className="price-slider-container">
                    <Box>
                      <Slider
                        valueLabelFormat={valueLabelFormat}
                        getAriaValueText={valuetext}
                        value={value}
                        step={5}
                        valueLabelDisplay="on"
                        marks={marks}
                        min={0}
                        size="large"
                        onChange={(_, newValue) =>
                          handleMembershipFeeChange(newValue)
                        }
                      />
                    </Box>
                  </div>

                  <FlexRow>
                    <div className="form-error">
                      <Error error={error} />
                    </div>
                    {loading ? (
                      <LoadingButton padding="11px 35px 11px 43px">
                        {savedMembershipFee !== null
                          ? pageText[6] + ' ' + pageText[7]
                          : pageText[6] + ' ' + pageText[7]}
                      </LoadingButton>
                    ) : (
                      <ActionButtons
                        padding="11px 35px"
                        onClick={() => {
                          handleSubmit()
                        }}
                      >
                        <img src="/images/icons/card.svg" />{' '}
                        {savedMembershipFee !== null
                          ? pageText[6] + ' ' + pageText[7]
                          : pageText[6] + ' ' + pageText[7]}
                      </ActionButtons>
                    )}

                    <ActionButtons
                      blackText
                      padding="11px 35px"
                      background="#FCBB32"
                      onClick={() => {
                        handleChooePaypal()
                      }}
                    >
                      {savedMembershipFee !== null
                        ? pageText[6] + ' by'
                        : pageText[6] + ' by'}

                      <img src="/images/icons/paypal.svg" />
                    </ActionButtons>
                  </FlexRow>
                </PriceChoiceBox>

                {/* Trust & Security / ID */}
                <SafetySection>
                  <FlexRowTrust gap="50px">
                    <SectionText>
                      <Title
                        color="#154549"
                        margin="0 0 20px 0"
                        size="22px"
                        sizemd="22px"
                        sizesm="26px"
                        dangerouslySetInnerHTML={{ __html: pageText[13] }}
                      />
                      <Subtitle
                        bold
                        color="#154549"
                        weight="400"
                        size="20px"
                        sizesm="22px"
                        margin="0 0 5px 0"
                        dangerouslySetInnerHTML={{ __html: pageText[14] }}
                      />
                      <Subtitle
                        color="#154549"
                        margin="0 0 20px 0"
                        size="17px"
                        sizesm="20px"
                        dangerouslySetInnerHTML={{ __html: pageText[15] }}
                      />
                      <Subtitle
                        bold
                        color="#154549"
                        weight="400"
                        size="20px"
                        sizesm="22px"
                        margin="0 0 5px 0"
                        dangerouslySetInnerHTML={{ __html: pageText[16] }}
                      />
                      <Subtitle
                        color="#154549"
                        margin="0 0 20px 0"
                        size="17px"
                        sizesm="20px"
                        dangerouslySetInnerHTML={{ __html: pageText[17] }}
                      />
                      <Subtitle
                        bold
                        color="#154549"
                        weight="400"
                        size="20px"
                        sizesm="22px"
                        margin="0 0 5px 0"
                        dangerouslySetInnerHTML={{ __html: pageText[18] }}
                      />
                      <Subtitle
                        color="#154549"
                        margin="0 0 20px 0"
                        size="17px"
                        sizesm="20px"
                        dangerouslySetInnerHTML={{ __html: pageText[19] }}
                      />
                      <Subtitle
                        color="#154549"
                        margin="0 0 40px 0"
                        size="17px"
                        sizesm="20px"
                        dangerouslySetInnerHTML={{ __html: pageText[20] }}
                      />
                    </SectionText>
                    <CustomImageWrapper>
                      <CustomImage
                        imageBig={'/images/homepage-v2/marie-big.jpg'}
                        imageSmall={'/images/homepage-v2/marie-small.jpg'}
                        name={pageText2[43]}
                        text={pageText2[44]}
                        country={'Ireland'}
                        countryFlag={'ie'}
                      />
                    </CustomImageWrapper>
                  </FlexRowTrust>
                </SafetySection>

                <Center>
                  <img
                    src="/images/icons/licensePaypal.svg"
                    alt=""
                    className="img-secured-by-stripe-mini-app2"
                  />
                  <img
                    src="/images/icons/licensePaypal-mobile.svg"
                    alt=""
                    className="img-secured-by-stripe-mini-mobile-app2"
                  />
                </Center>
              </form>
            )}
          </ContainerBox>
        )}
      </div>
    </div>
  )
}

export default withRouter(withAuth(ChooseMembershipFeeApp))
